import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9defb7f0: FaireBrandEntity = {
  token: "b_9defb7f0",
  type: "brand",
  name: "Ginger June Candle Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/d79038a9e5bc96e99936710cfc1d6d649fc843e110575e780934fc5ff3e21392.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8c05cbd306de68d7029d6d3856bf258ab9b2f6b6be73e425e97921c0a6902dc1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d79038a9e5bc96e99936710cfc1d6d649fc843e110575e780934fc5ff3e21392.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8c05cbd306de68d7029d6d3856bf258ab9b2f6b6be73e425e97921c0a6902dc1.jpeg",
  location: "HAYDEN, ID, USA",
  minimumOrderDollars: 120,
  rating: 5,
  reviewCount: 361,
  isTopShop: true,
  isInsider: true,
  description:
    "Ginger June Candle Co. started in my home kitchen in San Diego, CA in 2013 - we have since moved to beautiful Northern Idaho, grown our family & grown our amazing team to 5 incredible women. \n\nWe no longer work out of a 50 square foot kitchen but we still make & ship everything ourselves - now from our bright & happy warehouse near the lake.\n\nGinger June was my paternal grandmother's name, she passed away in 2019 but we try each day to keep her creative, kind & loving nature alive through this small business.\nWe also hope that you will be encouraged by our journey & tap into any creative inclinations you may have - you never know what may come of it!\n\n-Cass Collins\n\nGinger June Candle Co donates a portion of all sales each month to foster & adoption support for local Northern Idaho children.\n\nINSPIRATION + INGREDIENTS: \n\nAll of our ingredients are 100% cruelty free, fragrances are vegan, paraben and phthalate free. Our wax is made with sustainable US grown soybeans by a family owned company in Los Angeles.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:03.908Z",
    importedBy: "entity-db-cli",
  },
};
